import React from "react";

function Skills() {
  return (
    <section className="about-section">
      <div>
        <h2>03/ skills</h2>

        <div className="skills-container">
          <div className="skills">
            <div className="skills-column">
              <ul>
                <li>HTML5</li>
                <li>CSS</li>
                <li>JavaScript</li>
                <li>React</li>
              </ul>
            </div>
            <div className="skills-column">
              <ul>
                <li>Git</li>
                <li>PHP</li>
                <li>SQL</li>
                <li>Adobe Suite</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
